import { api } from './api';

export const getNotifications = async (page = 1, limit = 10) => {
  const response = await api.get('/notifications', {
    params: { page, limit }
  });
  return response;
};

export const getUnreadCount = async () => {
  const response = await api.get('/notifications/unread-count');
  return response;
};

export const markAsRead = async (notificationId) => {
  const response = await api.put(`/notifications/${notificationId}/read`);
  return response;
};

export const markAllAsRead = async () => {
  const response = await api.put('/notifications/mark-all-read');
  return response;
};

export const markActionTaken = async (notificationId) => {
  const response = await api.put(`/notifications/${notificationId}/action`);
  return response;
};

export const deleteNotification = async (notificationId) => {
  const response = await api.delete(`/notifications/${notificationId}`);
  return response;
};